import { render, staticRenderFns } from "./GenAICitationModal.vue?vue&type=template&id=3e5bdd21&scoped=true&"
import script from "./GenAICitationModal.vue?vue&type=script&lang=js&"
export * from "./GenAICitationModal.vue?vue&type=script&lang=js&"
import style0 from "./GenAICitationModal.vue?vue&type=style&index=0&id=3e5bdd21&prod&scoped=true&lang=css&"
import style1 from "./GenAICitationModal.vue?vue&type=style&index=1&id=3e5bdd21&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5bdd21",
  null
  
)

export default component.exports